import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Grid,
} from "@mui/material";
import DebitTransactionInvoice from "../DebitTransactionInvoice";
import CreditTransactionInvoice from "../CreditTransactionInvoice";
import DownloadIcon1 from "@mui/icons-material/Download";

const TransactionTable = ({
  data,
  activeTab,
  page,
  rowsPerPage,
  handleDownloadInvoice,
  formatDate,
  classes,
}) => (
  <TableContainer
    component={Paper}
    sx={{
      marginTop: "2%",
      overflowX: "auto",
      borderRadius: "12px 12px 0px 0px",
      boxShadow: "none",
    }}
  >
    <Table>
      <TableHead sx={{ backgroundColor: "#027BFE", color: "white" }}>
        <TableRow>
          {(activeTab === "DEBIT"
            ? [
                "Sr. No.",
                "Sender ID",
                "Receiver ID",
                "Transaction ID",
                "Date & Time",
                "Wallet Opening Balance",
                "Amount",
                "Wallet Closing Balance",
                "Remark",
                "Transaction Type",
                "Invoice",
              ]
            : [
                "Sr. No.",
                "Sender ID",
                "Receiver ID",
                "Transaction ID",
                "Date & Time",
                "Wallet Opening Balance",
                "Amount",
                "Wallet Closing Balance",
                "Remark",
                "Transaction Type",
                "Invoice",
              ]
          ).map((header) => (
            <TableCell
              key={header}
              sx={{
                color: "white",
                fontSize: { xs: "9px", sm: "14px" },
                fontWeight: "600",
              }}
            >
              {header}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>

      
<TableBody>
  {Array.isArray(data) &&
    data.map((row, index) => {
      const transaction = row.transaction || {};
      const senderAddress = row.sender_address || {};
      const receiverAddress = row.receiver_address || {};

      return (
        <TableRow
          key={transaction.tranxid}
          className={`${classes.tableRow} ${
            index % 2 === 0 ? classes.oddRow : classes.evenRow
          }`}
        >
          <TableCell>{page * rowsPerPage + index + 1}</TableCell>
          <TableCell>
            {transaction.senderName} ({transaction.senderId})
          </TableCell>
          <TableCell>
            {receiverAddress.id ? 
              `${receiverAddress.id} (${receiverAddress.city})` : "N/A"}
          </TableCell>
          <TableCell>{transaction.tranxid}</TableCell>
          <TableCell>{formatDate(transaction.date)}</TableCell>
          <TableCell>
            {Number(transaction.wOpeningBalance).toFixed(2)}
          </TableCell>
          <TableCell>{transaction.amount.toFixed(2)}</TableCell>
          <TableCell>
            {Number(transaction.wClosingBalance).toFixed(2)}
          </TableCell>
          <TableCell>{transaction.remark}</TableCell>
          <TableCell sx={{
            fontWeight: "bold",
            color: transaction.transactionType === "DEBIT" ? "red" : "green"
          }}>
            {transaction.transactionType}
          </TableCell>
          <TableCell align="center">
            <DownloadIcon1
              onClick={() => handleDownloadInvoice(transaction)}
              sx={{ cursor: "pointer" }}
            />
          </TableCell>

          {/* Hidden invoice */}
          <Grid style={{ position: "absolute", left: "-9999px" }}>
            <Grid id={`receipt-${transaction.senderId}`}>
              {transaction.transactionType === "DEBIT" ? (
                <DebitTransactionInvoice 
                  data={{
                    ...transaction,
                    senderAddress,
                    receiverAddress
                  }} 
                />
              ) : (
                <CreditTransactionInvoice
                  data={{
                    ...transaction,
                    senderAddress,
                    receiverAddress
                  }}
                />
              )}
            </Grid>
          </Grid>
        </TableRow>
      );
    })}
</TableBody>

    </Table>
  </TableContainer>
);

export default TransactionTable;
